module.exports = __webpack_public_path__ + "static/media/item_sli_hide_des.c511e809.png";